<template>
  <div>
    <b-overlay
      :show="topicsforlistsdata.length <= 0"
      opacity="0.9"
      spinner-variant="dark"
      spinner-small
      rounded
    >
      <template v-slot:overlay>
        <div class="text-center">
          <b-icon-circle
            variant="dark"
            font-scale="3"
            animation="throb"
          ></b-icon-circle>
          <h4>Retrieving Topics... Wait a Sec</h4>
        </div>
      </template>
      <b-container fluid>
        <b-row>
          <b-col class="m-0 p-1">
            <p class="text-center bs-text">
              You have Uploaded {{ topicsfortabledata.length }} Topic{{ topicsfortabledata.length > 1 ? 's' : '' }} for {{ details.clearance_organization }}
            </p>
            <div class="p-3" v-if="topicsforlistsdata.length > 0">
                <p class="text-center bs-text">{{ topicsforlistsdata[0].name }}</p>
                <p class="text-center bs-text" v-if="topicsforlistsdata.length > 0">This Table has {{ topicsforlistsdata[0].data.length }} rows</p>
                <tabler2 v-if="topicsforlistsdata.length > 0"  class="esq m-1 p-2" :datas="topicsforlistsdata[0].data" :fields="topicsforlistsdata[0].fields"></tabler2>
            </div>

            <b-form-group class="nested-form-group" label-for="institution">
                <b-input-group class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="search"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input type="search" v-model="searchQuery" @keyup="searchFilter" @focus="searching = true" placeholder="Search topics"></b-form-input>
                  <b-icon font-scale="1.5" class="close-button" @click="closeSearch" variant="secondary" icon="x"></b-icon>
                </b-input-group>
                
            </b-form-group>

            <p class="text-center">Click any Topic Block  to edit</p>
            <search-list v-if="searching == true" :searchingfor="searchfor" :filtereddata='searchResult'/>
            <div v-if="!searching">
                
                <div class="flex-listing">
                    <topicsForList
                      v-for="(topic, index) in usedatas"
                      :key="topic.track_id"
                      :topic="topic"
                      @refetch="refetchTopics"
                      :sn="index + 1"
                      class="listing-items"
                    />
                </div>
                <paginater :intervalnum="intervalnum" :pages="pages" :endnum="endnum" :endss="endss" :datalength="endss" @paginator="newPage" @changeInterval="effectInterval"></paginater>
            </div>

          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import topicsForList from "@/components/admin/topicsForList"
import searchList from "@/components/admin/searchList"
import Tabler2 from '@/components/admin/Tabler2';
import { mapState, mapActions } from "vuex";
import store from "@/store";
import Paginater from "@/components/Paginater"


export default {
  components: {
    topicsForList,
    Tabler2,
    searchList,
    Paginater
  },

  data() {
    return {
        startnum: 0,
        limitnum: this.endss,
        intervalnum: 10,
        endnum: 10,
        btnrange : this.endss,
        pages : 1,
        stockingdata : [{
            data : []
        }],
        dataretrieved : false,
        searching : false,
        searchQuery : "",
        searchResult : [],
        searchfor : 'topic'
    };
  },
  beforeRouteEnter(to, from, next) {
    let institution = to.query.institution
    let topicfor = to.params.identity
    let category = to.query.category
    let organization = store.state.loginmaster.details.clearance_organization
  
    store.dispatch("admin/fetchForTopics", {
        institution,
        topicfor,
        category,
        organization
    })
 
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.setnextid(to.params.trackid).then(() => {
      next();
    });
  },
  created() {
    let curpage = 1;    
    this.endnum = this.endnum * Number(curpage);
    this.pager = curpage


    // let category = to.params.category
    let organization = this.$store.state.loginmaster.details.clearance_organization

    this.pager = curpage        
    let stockobj = {
        institution : this.$route.query.institution,
        topicfor : this.$route.params.identity,
        category : this.$route.query.category,
        organization
    }

    this.queryForTopicStocks(stockobj)
  },
  methods: {
    ...mapActions("admin", ["fetchForTopics", "setnextid", "queryForTopicStocks"]),

      newPage(page){
          // alert(page)
          this.pages = page
          let newend = this.intervalnum * page;

          if (newend < this.endss) {
              this.endnum = newend;
              this.startnum = newend - this.intervalnum ;
          } else {
              this.endnum = this.endss;
              this.startnum = newend - this.intervalnum ;
          }

      },
      effectInterval(newinterval){
          this.intervalnum = newinterval
          this.pages = 1
          this.newPage(this.pages)
      },
      searchFilter(){
        this.searching = true
        let query = this.searchQuery
        let re = new RegExp(`${query}`, 'gi')
        let searchResult = this.topicsfortabledata.filter( x => re.test(x.topic) == true)
        this.searchResult = searchResult
      },
      refetchTopics(){
          let organization = this.$store.state.loginmaster.details.clearance_organization

          let stockobj = {
              institution : this.$route.query.institution,
              topicfor : this.$route.params.identity,
              category : this.$route.query.category,
              organization
          }

          this.fetchForTopics(stockobj)
          this.queryForTopicStocks(stockobj)
          // this.queryForStocks(this.stockObj)
      },
      closeSearch(){
        this.searching = false;
        this.searchQuery = ""
      }
    
  },
  computed: {
    ...mapState({
      details : state => state.loginmaster.details,
      name: (state) => state.loginmaster.details.fullname,
      trackid : state => state.loginmaster.details.trackid,
      topicsfortabledata: (state) => state.admin.topicsfortabledata,
      topicsforlistsdata : state => state.admin.topicsforlistsdata
    }),
    getpager(){
      let pagers = this.$route.query.page

      return Number(pagers);
    },
    usedatas() {
      return this.topicsfortabledata.slice(this.startnum, this.endnum);
    },
    endss() {
      let end = this.topicsfortabledata.length;
      return end;
    },
    ranger(){
        let ranger = Math.ceil(this.topicsfortabledata.length/this.intervalnum)
        return ranger
    },
  },
};
</script>

<style scoped>
.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.vmore {
  margin: 5px;
  padding: 10px;
}
.close-button{
    position : relative;
    left: -40px;
    top: 5px;
    cursor: pointer;
    z-index : 9999;
}
.bs-text{
  font-weight: bold;
  font-size: 1.3rem
}


@media screen and (max-width : 999px){
  .bs-text{
     font-size: 0.9rem;
  }
}
</style>
